import { useFormatter } from '@eneco/i18n';

export const useDateFormatter = () => {
  const { date: dateFormatter } = useFormatter();
  const shortDate = (date: Date | number | string) =>
    dateFormatter.medium(date, {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
    });
  const longDate = (date: Date | number | string) =>
    dateFormatter.long(date, {
      day: 'numeric',
      month: 'long',
      year: 'numeric',
    });
  return { shortDate, longDate };
};
